// frontend/src/pages/public/ForProviders/ForProvidersPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../components/SEO/SEO";
import PublicHeader from "../../../components/PublicHeader/PublicHeader";
import PublicFooter from "../../../components/PublicFooter/PublicFooter";

import {
  forProvidersHero,
  forProvidersFeatures,
  forProvidersValueSummary,
  forProvidersCtas,
} from "./ForProvidersContent";

import "./ForProvidersPage.css";

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

export default function ForProvidersPage() {
  return (
    <div className="ocf-providers">
      <SEO
        title="For Providers"
        description="Learn how AcceptingMD helps family doctors manage new patient intake, control accepting status, review standardized requests, and make clinic-controlled intake decisions."
      />
      <PublicHeader variant="solid" />

      {/* Hero */}
      <header className="ocf-providers-hero">
        <div className="ocf-providers-hero-inner">
          <div className="ocf-providers-hero-badge">{forProvidersHero.eyebrow}</div>
          <h1>{forProvidersHero.title}</h1>
          <p className="ocf-providers-hero-text">{forProvidersHero.subtitle}</p>
        </div>
      </header>

      <main className="ocf-providers-main">
        <div className="ocf-providers-sections">
          {/* Features Section */}
          <section className="ocf-providers-features">
            <h2>{forProvidersFeatures.title}</h2>
            <p className="ocf-providers-features-subtitle">{forProvidersFeatures.subtitle}</p>
            <ul className="ocf-providers-features-list">
              {forProvidersFeatures.bullets.map((bullet, idx) => (
                <li key={idx}>
                  <span className="ocf-providers-features-check"><CheckIcon /></span>
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Value Summary */}
          <section className="ocf-providers-value">
            <h2>{forProvidersValueSummary.title}</h2>
            <div className="ocf-providers-value-list">
              {forProvidersValueSummary.bullets.map((bullet, idx) => (
                <div key={idx} className="ocf-providers-value-item">
                  <span className="ocf-providers-value-num">{idx + 1}</span>
                  <span>{bullet}</span>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>

      {/* CTA */}
      <section className="ocf-providers-cta">
        <div className="ocf-providers-cta-inner">
          <h2>{forProvidersCtas.title}</h2>
          <p>{forProvidersCtas.subtitle}</p>
          <div className="ocf-providers-cta-buttons">
            <Link
              to={forProvidersCtas.primaryCta.to}
              className="ocf-providers-cta-btn ocf-providers-cta-btn--primary"
            >
              {forProvidersCtas.primaryCta.label}
              <span className="ocf-providers-cta-arrow"><ArrowRightIcon /></span>
            </Link>
            <Link
              to={forProvidersCtas.secondaryCta.to}
              className="ocf-providers-cta-btn ocf-providers-cta-btn--ghost"
            >
              {forProvidersCtas.secondaryCta.label}
            </Link>
            <Link
              to={forProvidersCtas.contactCta.to}
              className="ocf-providers-cta-btn ocf-providers-cta-btn--ghost"
            >
              {forProvidersCtas.contactCta.label}
            </Link>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
